import { useField } from 'formik'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Input } from 'almanac-ui/TextInputField/Input'
import Styles from 'screens/Campaigns/components/BatchCreateCampaignsModal/BatchCampaigns/CreateBatch/CreateBatch.module.scss'

export const StartDateField = () => {
  const [field,, { setValue }] = useField<string>('start_date')

  return (
    <label className={Styles.label}>
      <Heading level={4}>When do your campaigns start?</Heading>
      <Input
        placeholder='e.g. "September" or "Early Summer"'
        name="startDate"
        value={field.value}
        onChange={e => setValue(e.target.value)}
      />
    </label>
  )
}
